import React from 'react';
import PropTypes from 'prop-types';

import { layerStyles } from '../../styles/theme/foundation/layerStyles';

function StatusCircle({ status, color, cx = 0, cy = 8, r = 8 }) {
  const circleColor = color ?? layerStyles[status].color;

  return (
    <>
      <circle
        cx={cx}
        cy={cy}
        fill={circleColor}
        fillOpacity="0.2"
        r={r}
      />
      <circle
        cx={cx}
        cy={cy}
        fill={circleColor}
        r={r / 2}
      />
    </>
  );
}

StatusCircle.propTypes = {
  status: PropTypes.string,
  color: PropTypes.string,
  cx: PropTypes.number,
  cy: PropTypes.number,
  r: PropTypes.number
};

export default StatusCircle;
